const getEnvironment = () => window.dazn.application.environment;

const isStagingEnvironment = getEnvironment() === 'staging';
const isProdEnvironment = getEnvironment() === 'production' && !window.location.href.includes('beta.');
export { isStagingEnvironment, isProdEnvironment, getEnvironment };
